import { faArrowDownRight, faArrowUpRight } from '@fortawesome/pro-solid-svg-icons';
import { DefaultTheme } from 'styled-components';

import { AvailableThemes, ITheme } from './types';

export const getTheme = (key: AvailableThemes, theme: DefaultTheme): ITheme => {
  const themes = {
    received: {
      background: theme.colors.purple.color,
      position: 'left',
      icon: faArrowDownRight,
    },
    sent: {
      background: theme.colors.warning.color,
      position: 'right',
      icon: faArrowUpRight,
    },
    invite: {
      background: theme.colors.blue03.color,
      position: 'right',
      icon: faArrowUpRight,
    },
  };

  return themes[key];
};
